import React, { useEffect, useState } from "react";

import { setLeasingModal } from "./../../../contexts/leasing/actions/leasing.actions";
import { useLeasingDispatchContext } from "./../../../contexts/leasing/context/leasing.context";
import { BannerCarousel } from "./leasing-banner-carousel/leasing-banner-carousel";
import { BannerFlex } from "./leasing-banner-flex/leasing-banner-flex";
import { BannerData } from "./leasing-banner.data";
import * as Styled from "./leasing-banner.styled";
import { LeasingBannerModalProps } from "./leasing-banner.types";
import { useTracking } from "../../../utils/tracking/use-tracking";

export const LeasingBanner = () => {
  const dispatch = useLeasingDispatchContext();
  const { trackEvent } = useTracking();
  const [width, setWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    // check window size to render either the carousel or the normal banner
    window.addEventListener("resize", () => {
      handleResize();
    });

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOpenModal = ({
    type,
    title,
    tracking,
  }: LeasingBannerModalProps) => {
    dispatch(
      setLeasingModal({
        show: true,
        type: type,
        title: title,
      }),
    );
    trackEvent({ trackingLabel: tracking });
  };

  const { data } = BannerData();

  return (
    <Styled.Banner>
      <Styled.BannerBackground />
      {width < 950 ? (
        <BannerCarousel handleOpenModal={handleOpenModal} bannerData={data} />
      ) : (
        (width >= 950 || width === undefined) && (
          <BannerFlex handleOpenModal={handleOpenModal} bannerData={data} />
        )
      )}
    </Styled.Banner>
  );
};
